import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { RepresentanteSituacaoPipe, RepresentanteSituacaoColorPipe, RepresentanteSituacaoBadgePipe } from './pipes';


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        RepresentanteSituacaoPipe,
        RepresentanteSituacaoColorPipe,
        RepresentanteSituacaoBadgePipe
    ],
    exports: [
        SharedModule,

        RepresentanteSituacaoPipe,
        RepresentanteSituacaoColorPipe,
        RepresentanteSituacaoBadgePipe
    ],
    providers: [
        RepresentanteSituacaoPipe,
        RepresentanteSituacaoColorPipe,
        RepresentanteSituacaoBadgePipe
    ]
})
export class RepresentanteSituacaoModule { }
